import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import ClientSettingsData from './ClientSettingsData';
import ClientSettingsDrawer from './ClientSettingsDrawer';

const ClientSettings = (props) => {
  const showSettings = props.showSettings;
  const openDrawerView = props.openDrawerView;
  const setOpenDrawerView = props.setOpenDrawerView;

  return (
    <>
      {
        !showSettings &&
        <Box sx={{width: '23vw', maxWidth: '296px', position: 'sticky', top: 16}}>
          <ClientSettingsData
            {...props}
          />
        </Box>
      }
      {
        openDrawerView &&
        <ClientSettingsDrawer
          settingsDrawerOpen={openDrawerView}
          setSettingsDrawerOpen={setOpenDrawerView}
        >

          <ClientSettingsData
            {...props}
          />
        </ClientSettingsDrawer>
      }
    </>
  );
};

ClientSettings.propTypes = {
  showSettings: PropTypes.bool.isRequired,
  openDrawerView: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientSettings));
